(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctr-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.stickyTypeDesktop = this.getAttribute('data-sticky-type-desktop') || 'none';
        this.stickyTypeMobile = this.getAttribute('data-sticky-type-mobile') || 'none';
        this.headerBounds = {};
        this.mobileMq = window.matchMedia('(max-width: 989px)');

        this.setHeaderHeight();

        this.mobileMq.addEventListener('change', this.onBreakpointChange.bind(this));

        if (this.isAlwaysSticky()) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      getActiveStickyType() {
        return this.mobileMq.matches ? this.stickyTypeMobile : this.stickyTypeDesktop;
      }

      isAlwaysSticky() {
        const type = this.getActiveStickyType();
        return type === 'always' || type === 'reduce-logo-size';
      }

      isStickyDisabled() {
        return this.getActiveStickyType() === 'none';
      }

      isMobileNavMode() {
        return (
          this.getActiveStickyType() === 'on-scroll-up-nav' &&
          !!this.querySelector('.ctr-header__mobile-nav')
        );
      }

      onBreakpointChange() {
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'ctr-header--nav-sticky',
          'animate'
        );

        if (this.isAlwaysSticky()) {
          this.header.classList.add('shopify-section-header-sticky');
        } else {
          this.header.classList.remove('shopify-section-header-sticky');
        }

        this.setHeaderHeight();
      }

      setHeaderHeight() {
        const bar = this.querySelector('.ctr-header__bar');
        const nav = this.querySelector('.ctr-header__mobile-nav');

        if (bar) {
          document.documentElement.style.setProperty(
            '--ctr-header-bar-height',
            `${bar.offsetHeight}px`
          );
        }

        let height = this.header.offsetHeight;
        if (this.header.classList.contains('ctr-header--nav-sticky') && nav) {
          height = nav.offsetHeight;
        }

        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (this.isStickyDisabled()) return;
        if (this.isAlwaysSticky()) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.isStickyDisabled() || this.isAlwaysSticky()) return;

        if (this.isMobileNavMode()) {
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');

          // Apply sticky first, then collapse so `top` can transition.
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.header.classList.add('ctr-header--nav-sticky');
              this.setHeaderHeight();
            });
          });

          this.closeMenuDisclosure();
          this.closeSearchModal();
          return;
        }

        this.header.classList.remove('ctr-header--nav-sticky');
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.setHeaderHeight();
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.isStickyDisabled() || this.isAlwaysSticky()) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        // Keep animate for one frame so collapsing `top` can ease back out.
        requestAnimationFrame(() => {
          this.header.classList.remove('shopify-section-header-hidden', 'ctr-header--nav-sticky');
          this.setHeaderHeight();
        });
      }

      reset() {
        if (this.isStickyDisabled() || this.isAlwaysSticky()) return;
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'ctr-header--nav-sticky',
          'animate'
        );
        this.setHeaderHeight();
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal) this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
